import { Link, NavLink } from 'react-router-dom';
import { ChevronDown, ShoppingCart, User } from 'lucide-react';
import { useState } from 'react';
import { categories } from '@/data/homeContent';
import { useCartStore } from '@/stores/cartStore';
import { useAuthStore } from '@/stores/authStore';
import { CartDrawer } from './CartDrawer';
import { BrandLogo } from './BrandLogo';
import { HeaderSearch } from './HeaderSearch';
import { cn } from '@/lib/utils';

const navLinks = [
  { to: '/catalogo', label: 'Catálogo' },
  { to: '/kits', label: 'Kits' },
];

export function Header() {
  const [categoriesOpen, setCategoriesOpen] = useState(false);
  const itemCount = useCartStore((s) => s.itemCount());
  const toggleCart = useCartStore((s) => s.toggleCart);
  const token = useAuthStore((s) => s.token);
  const loggedIn = !!token;

  return (
    <>
      <header className="sticky top-0 z-50 border-b border-surface-200 bg-white/95 shadow-nav backdrop-blur-md lg:bg-white">
        <div className="container-app flex h-14 items-center justify-between gap-3 lg:h-[4.25rem]">
          <BrandLogo />

          <nav className="hidden items-stretch lg:flex">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                className={({ isActive }) =>
                  cn(
                    'flex items-center border-b-2 px-4 text-sm font-medium transition-colors',
                    isActive
                      ? 'border-brand-600 text-brand-700'
                      : 'border-transparent text-surface-600 hover:text-surface-900',
                  )
                }
              >
                {link.label}
              </NavLink>
            ))}

            <div
              className="relative flex items-center"
              onMouseEnter={() => setCategoriesOpen(true)}
              onMouseLeave={() => setCategoriesOpen(false)}
            >
              <button
                type="button"
                className="flex h-full items-center gap-1 px-4 text-sm font-medium text-surface-600 hover:text-surface-900"
              >
                Líneas
                <ChevronDown
                  className={cn('h-3.5 w-3.5', categoriesOpen && 'rotate-180')}
                />
              </button>
              {categoriesOpen && (
                <div className="absolute left-0 top-full z-50 min-w-[180px] border border-surface-200 bg-white py-1 shadow-card">
                  {categories.map(({ slug, label }) => (
                    <Link
                      key={slug}
                      to={`/catalogo?categoria=${slug}`}
                      className="block px-3.5 py-2 text-sm text-surface-700 hover:bg-surface-50"
                    >
                      {label}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          </nav>

          <HeaderSearch />

          <div className="flex items-center gap-1.5">
            <Link
              to={loggedIn ? '/cuenta' : '/ingresar'}
              className="icon-btn hidden sm:inline-flex"
              aria-label={loggedIn ? 'Mi cuenta' : 'Iniciar sesión'}
              title={loggedIn ? 'Mi cuenta' : 'Iniciar sesión'}
            >
              <User className="h-4 w-4" />
            </Link>

            <button
              type="button"
              onClick={() => toggleCart(true)}
              className="relative icon-btn"
              aria-label="Carrito"
            >
              <ShoppingCart className="h-4 w-4" />
              {itemCount > 0 && (
                <span className="absolute -right-1 -top-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-brand-600 px-0.5 font-mono text-[9px] font-bold text-white">
                  {itemCount > 99 ? '99+' : itemCount}
                </span>
              )}
            </button>
          </div>
        </div>
      </header>
      <CartDrawer />
    </>
  );
}
